import { render } from "./AddAgent.vue?vue&type=template&id=6e0e54fa&scoped=true"
import script from "./AddAgent.vue?vue&type=script&lang=js"
export * from "./AddAgent.vue?vue&type=script&lang=js"

import "./AddAgent.vue?vue&type=style&index=0&id=6e0e54fa&scoped=true&lang=css"

import exportComponent from "D:\\project\\idbrand\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0e54fa"]])

export default __exports__